import classnames from "classnames";
import * as React from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { ApplicantType } from "../Map/enums";
import { Form } from "./Form";
import { formField } from "./formFields";
import { Upload } from "./Upload";

export const FormSection = ({ error }: { error: boolean }): JSX.Element => {
    const {
        validateForm,
        setIsFormValid,
        setFormData,
        resetForm,
        setResetForm,
        rawData,
        setRawData,
        applicantType,
        setApplicantType,
        formDefaultData
    } = useRegistrationContext();

    const onFormValidated = (isValid: boolean) => {
        isValid && setFormData(rawData);
        setIsFormValid(isValid ? Date.now() : null);
    };

    const changeForm = (formType: ApplicantType) => {
        formType !== applicantType && setResetForm(Date.now());
        setApplicantType(formType);
    };

    return (
        <>
            {error ? <div className="error-overlay">Kļūda servera savienojumā!</div> : null}
            <div className="tab-buttons">
                <div
                    className={classnames("cv-button unselectable", {
                        "cv-button-active": applicantType === ApplicantType.Individual
                    })}
                    onClick={() => changeForm(ApplicantType.Individual)}
                >
                    Fiziska persona
                    {applicantType === ApplicantType.Individual && <div className="triangle-bottom"></div>}
                </div>
                <div
                    className={classnames("cv-button unselectable", {
                        "cv-button-active": applicantType === ApplicantType.Company
                    })}
                    onClick={() => changeForm(ApplicantType.Company)}
                >
                    Juridiska persona
                    {applicantType === ApplicantType.Company && <div className="triangle-bottom"></div>}
                </div>
            </div>
            {applicantType === ApplicantType.Individual ? (
                <Form
                    fieldNames={[
                        formField.Name,
                        formField.Surname,
                        formField.PersonalCode,
                        formField.Address,
                        formField.Phone,
                        formField.Email,
                        formField.Notes
                    ]}
                    onChange={setRawData}
                    validateForm={validateForm}
                    onFormValidated={onFormValidated}
                    resetForm={resetForm}
                    defaultValues={Object.keys(formDefaultData).length ? formDefaultData : null}
                ></Form>
            ) : (
                <Form
                    fieldNames={[
                        formField.Company,
                        formField.RegistrationNumber,
                        formField.Address,
                        formField.ContactPerson,
                        formField.Phone,
                        formField.Email,
                        formField.Notes
                    ]}
                    onChange={setRawData}
                    validateForm={validateForm}
                    onFormValidated={onFormValidated}
                    resetForm={resetForm}
                    defaultValues={Object.keys(formDefaultData).length ? formDefaultData : null}
                ></Form>
            )}
            <div className="upload-section">
                <div className="upload-label">Pielikumi:</div>
                <div className="upload-component-container">
                    <Upload></Upload>
                </div>
            </div>
        </>
    );
};
